/**
 * The variant names planning-service resolves for an experiment's arms.
 *
 * Kept out of `useExperiment` so the MST store can compare against them without importing a hook —
 * `store/mst/UI.ts` reaching into `hooks/useExperiment.ts` would close an import cycle back through
 * `store/mst/index.ts`.
 */

/** Variant served when an organization is not bucketed into an experiment. */
export const CONTROL = 'control';

/** Variant served to organizations bucketed into an experiment's treatment arm. */
export const TREATMENT = 'treatment';
